// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o8-0";
export var animationContainer = "_o8-1";
export var itemPrice = "_o8-a";
export var itemizedContent = "_o8-9";
export var itemizedHeader = "_o8-7";
export var itemizedRow = "_o8-8";
export var itemizedSection = "_o8-6";
export var modalContent = "_o8-2";
export var orderName = "_o8-3";
export var refundOption = "_o8-4";
export var refundOptionsContainer = "_o8-5";
export var shippingLabel = "_o8-b";
export var totalRow = "_o8-c";